import Breadcrumb from '@/components/base/Breadcrumb';
import { aboutInfo } from '@/mocks/about';

export default function About() {
  const contactFormUrl = 'https://readdy.ai/api/form/d9s98o4nlsngrm4lmiig';

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '每日大赛Yandex',
    url: 'https://yandex-contest.com/',
    description: aboutInfo.brandIntro,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '北京市海淀区中关村科技园区Yandex大厦18层',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      email: 'support@yandex-contest.cn',
      availableLanguage: ['Chinese'],
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://yandex-contest.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 每日大赛Yandex官网',
    description: '了解每日大赛Yandex品牌故事、发展历程、信誉口碑及联系方式',
    url: 'https://yandex-contest.com/about',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <main className="min-h-screen pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-4">
                关于我们
              </h1>
              <p className="text-sm text-foreground-600 mt-2">了解每日大赛Yandex的品牌故事与发展历程</p>
            </div>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                  品牌介绍
                </h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  {aboutInfo.brandIntro}
                </p>
                <div className="flex flex-col gap-3">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                      <i className="ri-focus-2-line text-base"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">我们的使命</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.mission}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                      <i className="ri-eye-line text-base"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">我们的愿景</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.vision}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative rounded-xl overflow-hidden h-[300px] md:h-[360px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20creative%20design%20elements%2C%20warm%20lighting%2C%20collaborative%20workspace%20with%20wooden%20furniture%20and%20green%20plants%2C%20tech%20company%20headquarters%20vibe%2C%20clean%20minimal%20aesthetic%2C%20professional%20atmosphere%2C%20soft%20natural%20light%20through%20large%20windows%2C%20abstract%20art%20pieces%20on%20walls&width=800&height=600&seq=about-brand-2025&orientation=landscape"
                  alt="每日大赛Yandex品牌办公环境"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-background-300/60 transform -translate-x-1/2"></div>
              <div className="space-y-8">
                {aboutInfo.history.map((item, index) => (
                  <div
                    key={item.year}
                    className={`flex flex-col lg:flex-row items-center gap-4 ${
                      index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                    }`}
                  >
                    <div className="flex-1 flex justify-end">
                      <div
                        className={`w-full lg:w-[calc(50%-2rem)] p-4 rounded-xl bg-background-50 border border-background-200/70 ${
                          index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'
                        }`}
                      >
                        <span className="inline-block px-3 py-1 rounded-full text-xs font-bold bg-primary-100 text-primary-700 mb-2">
                          {item.year}
                        </span>
                        <p className="text-sm text-foreground-700">{item.event}</p>
                      </div>
                    </div>
                    <div className="hidden lg:flex w-10 h-10 flex-shrink-0 rounded-full bg-primary-500 text-background-50 items-center justify-center z-10">
                      <i className="ri-check-line"></i>
                    </div>
                    <div className="flex-1 hidden lg:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
              信誉口碑
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {aboutInfo.reputation.map((item) => (
                <div
                  key={item.title}
                  className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center hover:border-primary-300 transition-all"
                >
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-1">
                    {item.value}
                  </div>
                  <div className="text-xs text-foreground-500">{item.title}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                  联系我们
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5">公司地址</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.contact.address}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5">电子邮箱</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.contact.email}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5">客服电话</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.contact.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-100 text-foreground-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5">工作时间</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.contact.workingHours}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-wechat-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5">微信公众号</h4>
                      <p className="text-xs text-foreground-600">{aboutInfo.contact.wechat}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                  在线咨询
                </h2>
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <form
                    id="contact-form"
                    action={contactFormUrl}
                    method="POST"
                    data-readdy-form="true"
                  >
                    <div className="space-y-4">
                      <div>
                        <label htmlFor="name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                          您的姓名 <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          className="w-full px-3.5 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                          电子邮箱 <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          className="w-full px-3.5 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                          咨询内容 <span className="text-red-500">*</span>
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-3.5 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                          placeholder="请描述您的问题（最多500字）"
                        ></textarea>
                        <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                      </div>
                      <div className="website-alt-field">
                        <input
                          type="text"
                          name="website_alt"
                          tabIndex={-1}
                          autoComplete="off"
                          aria-hidden="true"
                          readOnly
                        />
                      </div>
                      <button
                        type="submit"
                        className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        发送咨询
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}